<template>
  <div class="outer">
    <div class="wrapper">
      <div class="cc-logo">
        <img src="../../assets/img/payments/visa.png" alt="Visa" v-if="brand == 'Visa'">
        <img src="../../assets/img/payments/visaelectron.png" alt="Visa Electron" v-else-if="brand == 'Visa Electron'">
        <img src="../../assets/img/payments/mastercard.png" alt="MasterCard" v-else-if="brand == 'MasterCard'">
        <img src="../../assets/img/payments/maestro.png" alt="Maestro" v-else-if="brand == 'Maestro'">
        <img src="../../assets/img/payments/americanexpress.png" alt="American Express"
             v-else-if="brand == 'American Express'">
        <img src="../../assets/img/payments/cirrus.png" alt="Cirrus" v-else-if="brand == 'Cirrus'">
        <img src="../../assets/img/payments/dinersclub.png" alt="Diners Club" v-else-if="brand == 'Diners Club'">
        <img src="../../assets/img/payments/discover.png" alt="Discover" v-else-if="brand == 'Discover'">
        <img src="../../assets/img/payments/jcb.png" alt="JCB" v-else-if="brand == 'JCB'">
      </div>
      <div class="details">
        <div>****{{ last4 }}</div>
        <div>Exp: {{ expMonth }}/{{ expYear }}</div>
      </div>
      <div class="action">
        <SecondaryButton @click.prevent="editPayment">Edit payment</SecondaryButton>
      </div>
    </div>
  </div>
</template>
<script>
import SecondaryButton from "../buttons/SecondaryButton";

export default {
  name: 'payment-source',
  components: {SecondaryButton},
  props: {
    expMonth: {
      type: Number,
      default: null,
    },
    expYear: {
      type: Number,
      default: null,
    },
    last4: {
      type: String,
      default: null,
    },
    brand: {
      type: String,
      default: null,
    },
  },
  methods: {
    editPayment() {
      this.$emit('edit-payment')
    }
  }
}
</script>
<style scoped lang="scss">
h1 {
  margin-bottom: 3rem;
}

.outer {
  width: 100%;
  //max-width: 600px;
  .wrapper {
    width: 100%;
  }
}

.wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  @media screen and (max-width: 750px) {
    //flex-direction: column;
  }

  & > div {
    align-self: center;
    padding-bottom: 0.5rem;
    @media screen and (max-width: 750px) {
      //align-self: flex-start;
    }

    &.cc-logo {
      @media screen and (max-width: 750px) {
        //padding-bottom: 1rem;
      }
    }

    &.action {
      align-self: flex-start;
      margin-top: -8px;
      flex-grow: 1;
      text-align: right;
      @media screen and (max-width: 750px) {
        //margin-top: 0.5rem;
        //flex-basis: 100%;
      }
    }

    &.details {
      flex-grow: 10;
    }
  }

}

.details {

  padding-left: 20px;
  padding-right: 20px;
  @media screen and (max-width: 750px) {
    //margin-left: 0;
  }

  & > div {
    &:not(:last-child) {
      padding-bottom: 1rem;
    }
  }
}

.action {
  @media screen and (max-width: 750px) {
    //margin-left: 0;
  }
}


</style>